(function () {
  'use strict';

  var CARD_SELECTOR = '[data-zinus-home-card-commerce]';

  function parseVariantData(card) {
    var jsonElement = card.querySelector('[data-zinus-home-commerce-variants]');

    if (!jsonElement) return null;

    try {
      return JSON.parse(jsonElement.textContent);
    } catch (error) {
      console.error('ZINUS Home card commerce: no se pudieron leer las variantes.', error);
      return null;
    }
  }

  function initCard(card) {
    if (!card || card.dataset.zinusHomeCardCommerceReady === 'true') return;

    var data = parseVariantData(card);
    var variants = data && Array.isArray(data.variants) ? data.variants : [];
    var optionsWrap = card.querySelector('[data-zinus-home-commerce-options]');

    if (!variants.length || !optionsWrap) {
      card.dataset.zinusHomeCardCommerceReady = 'true';
      return;
    }

    var variantInput = card.querySelector('[data-zinus-home-commerce-variant-id]');
    var initialVariantId = variantInput ? variantInput.value : '';
    var initialVariant = variants.find(function (variant) {
      return String(variant.id) === String(initialVariantId) && variant.eligible === true;
    });

    if (!initialVariant || String(initialVariant.id) !== String(data.initial_variant_id)) return;

    var selectedOptions = initialVariant.options.slice();
    var image = card.querySelector('.zinus-home-product-card__image img');
    var price = card.querySelector('[data-zinus-home-commerce-price]');
    var compare = card.querySelector('[data-zinus-home-commerce-compare]');
    var installment = card.querySelector('[data-zinus-home-commerce-msi]');
    var addToCart = card.querySelector('[data-zinus-home-commerce-atc]');
    var saleBadge = card.querySelector('[data-zinus-sale-badge]');
    var reviewsLink = card.querySelector('[data-zinus-reviews-link]');
    var liveStatus = card.querySelector('[data-zinus-home-commerce-status]');
    var productLinks = card.querySelectorAll('[data-zinus-home-commerce-product-link]');
    var addToCartLabel = addToCart ? addToCart.textContent.trim() : 'Agregar al carrito';

    function isEligible(variant) {
      return Boolean(variant && variant.eligible === true);
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === options[index];
        });
      });
    }

    function findEligibleVariantForValue(optionIndex, value) {
      return variants.find(function (variant) {
        return isEligible(variant) && variant.options[optionIndex] === value;
      });
    }

    function updateImage(variant) {
      if (!image || !variant.image) return;

      if (variant.image.srcset) image.srcset = variant.image.srcset;
      if (variant.image.src) image.src = variant.image.src;
      image.alt = variant.image.alt || card.dataset.productTitle || '';

      if (variant.image.width) image.width = variant.image.width;
      if (variant.image.height) image.height = variant.image.height;
    }

    function updateDiscount(variant) {
      if (!saleBadge) return;

      var compareAt = Number(variant.compare_at_price || 0);
      var currentPrice = Number(variant.price || 0);
      var percentage = compareAt > currentPrice && compareAt > 0
        ? Math.round(((compareAt - currentPrice) * 100) / compareAt)
        : 0;

      if (percentage > 0) {
        saleBadge.textContent = '-' + percentage + '%';
        saleBadge.setAttribute('aria-label', percentage + '% de descuento');
        saleBadge.hidden = false;
      } else {
        saleBadge.hidden = true;
      }
    }

    function updateOptionControls() {
      optionsWrap.querySelectorAll('[data-zinus-home-commerce-option]').forEach(function (optionWrap) {
        var optionIndex = Number(optionWrap.dataset.optionIndex);
        var valueLabel = optionWrap.querySelector('[data-zinus-home-commerce-option-value]');

        if (valueLabel) valueLabel.textContent = selectedOptions[optionIndex] || '';

        optionWrap.querySelectorAll('[data-zinus-home-commerce-option-button]').forEach(function (button) {
          var value = button.dataset.optionValue;
          var isSelected = value === selectedOptions[optionIndex];
          var probe = selectedOptions.slice();
          var exactVariant;
          var eligibleFallback;

          probe[optionIndex] = value;
          exactVariant = findVariant(probe);
          eligibleFallback = findEligibleVariantForValue(optionIndex, value);

          var changesAnotherOption = !isEligible(exactVariant) && Boolean(eligibleFallback);

          button.classList.toggle('is-selected', isSelected);
          button.classList.toggle('is-unavailable', !isEligible(exactVariant));
          button.setAttribute('aria-checked', isSelected ? 'true' : 'false');
          button.setAttribute('aria-disabled', eligibleFallback ? 'false' : 'true');
          button.setAttribute(
            'aria-label',
            changesAnotherOption
              ? value + '. Al elegirla puede cambiar otra opción para usar una variante disponible.'
              : value
          );
          if (changesAnotherOption) {
            button.title = 'Puede cambiar otra opción para usar una variante disponible';
          } else {
            button.removeAttribute('title');
          }
          button.tabIndex = isSelected ? 0 : -1;
          button.disabled = !eligibleFallback;
        });
      });
    }

    function updateCard(variant, announce, changedAnotherOption) {
      if (!isEligible(variant)) return;

      selectedOptions = variant.options.slice();
      card.dataset.selectedVariantId = variant.id;

      updateOptionControls();
      updateImage(variant);
      updateDiscount(variant);

      productLinks.forEach(function (link) {
        link.href = variant.url;
        link.dataset.variantId = variant.id;
      });

      if (reviewsLink) reviewsLink.href = variant.url + '#judgeme_product_reviews';
      if (price) price.textContent = variant.price_formatted;

      if (compare) {
        if (Number(variant.compare_at_price || 0) > Number(variant.price || 0)) {
          compare.textContent = variant.compare_formatted;
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }

      if (installment) installment.textContent = variant.msi_formatted;
      if (variantInput) variantInput.value = variant.id;

      if (addToCart) {
        addToCart.disabled = !isEligible(variant);
        addToCart.textContent = isEligible(variant) ? addToCartLabel : 'Agotado';
        addToCart.dataset.variantId = variant.id;
      }

      if (announce && liveStatus) {
        liveStatus.textContent = changedAnotherOption
          ? 'Se seleccionó ' + variant.options.join(', ') + ' porque la combinación anterior no está disponible. Precio ' + variant.price_formatted + '.'
          : 'Variante ' + variant.options.join(', ') + ' seleccionada. Precio ' + variant.price_formatted + '.';
      }

      if (announce) {
        card.dispatchEvent(new CustomEvent('zinus-home-card-commerce:variant-change', {
          bubbles: true,
          detail: {
            productId: card.dataset.productId,
            productHandle: card.dataset.productHandle,
            variantId: variant.id,
            price: variant.price,
            available: variant.available,
            eligible: variant.eligible
          }
        }));
      }
    }

    function selectValue(button) {
      var optionWrap = button.closest('[data-zinus-home-commerce-option]');

      if (!optionWrap || button.disabled) return;

      var optionIndex = Number(optionWrap.dataset.optionIndex);
      var probe = selectedOptions.slice();
      var selectedVariant;
      var usedFallback = false;

      probe[optionIndex] = button.dataset.optionValue;
      selectedVariant = findVariant(probe);

      if (!isEligible(selectedVariant)) {
        selectedVariant = findEligibleVariantForValue(optionIndex, button.dataset.optionValue);
        usedFallback = true;
      }

      if (!isEligible(selectedVariant)) return;

      updateCard(selectedVariant, true, usedFallback);
      button.dataset.variantId = selectedVariant.id;
      button.focus();
    }

    optionsWrap.addEventListener('click', function (event) {
      var button = event.target.closest('[data-zinus-home-commerce-option-button]');

      if (!button || !optionsWrap.contains(button)) return;

      selectValue(button);
    });

    optionsWrap.addEventListener('keydown', function (event) {
      var button = event.target.closest('[data-zinus-home-commerce-option-button]');

      if (!button || !optionsWrap.contains(button)) return;
      if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;

      var group = button.closest('[role="radiogroup"]');
      var buttons = Array.from(group.querySelectorAll('[data-zinus-home-commerce-option-button]')).filter(function (candidate) {
        return !candidate.disabled;
      });
      var currentIndex = buttons.indexOf(button);
      var nextIndex = currentIndex;

      if (!buttons.length) return;

      event.preventDefault();

      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = buttons.length - 1;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % buttons.length;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;

      selectValue(buttons[nextIndex]);
    });

    updateCard(initialVariant, false, false);
    card.dataset.zinusHomeCardCommerceReady = 'true';
  }

  function init(root) {
    var scope = root || document;

    if (scope.matches && scope.matches(CARD_SELECTOR)) initCard(scope);
    scope.querySelectorAll(CARD_SELECTOR).forEach(initCard);
  }

  if (window.ZinusHomeCardCommerce && typeof window.ZinusHomeCardCommerce.init === 'function') {
    window.ZinusHomeCardCommerce.init(document);
    return;
  }

  window.ZinusHomeCardCommerce = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
